export default __webpack_public_path__ + "static/media/ataur (1).f5e767e6.jpg";